<template>
  <div class="empty b pc ac">
    <div class="imgBox">
      <img src="../../assets/images/common/no_data.png" alt="" />
    </div>
    <p class="text">{{ text }}</p>
  </div>
</template>
<script>
export default {
  props: {
    // 空态文案：原先只在 mounted 读取一次，文案变化不会更新，这里改为响应式
    text: {
      type: String,
      default: '暂无数据'
    }
  }
};
</script>
<style lang="scss" scoped>
.empty {
  width: 100%;
  padding: 30px 0;
  display: flex;
  flex-direction: column;
  .imgBox {
    width: 150px;
    img {
      width: 100%;
    }
  }
  .text {
    font-size: 16px;
    padding: 0 30px;
    color: #666;
    font-weight: normal;
  }
}
</style>
